import { motion } from "framer-motion";
import { PROMISE } from "@/constants/testIds";
import Spade from "@/components/Spade";
import Divider from "@/components/Divider";

export default function Promise() {
    return (
        <section
            id="promise"
            data-testid={PROMISE.root}
            className="relative py-20 md:py-28"
        >
            <Divider label="the promise" />
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
                <div className="absolute inset-0 flex items-center justify-center opacity-[0.05] pointer-events-none">
                    <Spade size={520} />
                </div>
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.9 }}
                    className="relative text-xs uppercase tracking-[0.35em] text-[var(--accent-gold)] mb-6"
                >
                    Our Promise
                </motion.p>
                <motion.p
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 1, delay: 0.1 }}
                    className="relative font-display text-3xl md:text-4xl lg:text-5xl leading-[1.15] text-[var(--text-primary)]"
                >
                    We don&apos;t do vague promises. We build systems that{" "}
                    <span className="italic text-[var(--accent-champagne)]">compound</span>.
                    More reach, more attention, more sales, week over week. Every brand is
                    different, so every strategy is built specifically for yours.{" "}
                    <span className="font-fraktur text-[var(--accent-gold)]">
                        What doesn&apos;t change
                    </span>{" "}
                    is the result: growth that actually turns into revenue.
                </motion.p>
            </div>
        </section>
    );
}
